import { Component, OnDestroy, OnInit } from '@angular/core';
import { Calendar2ComponentDef } from '@df/ui/form/calendar/calendar2.component.def';
@Component({
    selector: 'calendar',
    templateUrl: 'calendar.html',
    styleUrls: ['calendar.scss']
})
export class CalendarComponent extends Calendar2ComponentDef implements OnInit, OnDestroy {}
